import ParentSecurityPostureDashboard from './ParentSecurityPostureDashboard'
import TrailsSecurityPostureDashboard from './TrailsSecurityPostureDashboard'
import AgentsSecurityPostureDashboard from './AgentsSecurityPostureDashboard'
import PrivilegedSecurityPostureDashboard from './PrivilegedSecurityPostureDashboard'
import HomeDashboard from './HomeDashboard'

export {
  ParentSecurityPostureDashboard,
  TrailsSecurityPostureDashboard,
  AgentsSecurityPostureDashboard,
  PrivilegedSecurityPostureDashboard,
  HomeDashboard
}



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js